import { quantityMapping } from '../../../utils/dataMappings';

export const getSignupQuantityText = (signupItem) => { 
    return signupItem.PaymentTypeRequiresQuant ? String(quantityMapping(signupItem.NoOfEntriesOnPassLeft)) : null;
};